import * as React from 'react'
import { usePostHog } from '@posthog/react'
import { useState, useEffect } from 'react'

const ENGLISH_TRANSLATIONS = {
  message: 'We use cookies to improve your experience and analyze our website.',
  privacyLink: 'Privacy Policy',
  privacyHref: '/privacy/',
  decline: 'Decline',
  accept: 'Accept',
}

type ConsentStatus = 'pending' | 'granted' | 'denied' | undefined

export function PrivacyNoticeBanner() {
  const translations = ENGLISH_TRANSLATIONS
  const posthog = usePostHog()
  const [consentStatus, setConsentStatus] = useState<ConsentStatus>(undefined)

  useEffect(() => {
    if (posthog) {
      const status = posthog.get_explicit_consent_status()
      // If status is undefined, treat it as 'pending' (no consent decision made yet)
      setConsentStatus(status ?? 'pending')
    }
  }, [posthog])

  const handleAccept = () => {
    if (posthog) {
      posthog.opt_in_capturing()
      setConsentStatus('granted')
    }
  }

  const handleDecline = () => {
    if (posthog) {
      posthog.opt_out_capturing()
      setConsentStatus('denied')
    }
  }

  // Show banner only if consent status is 'pending' (or undefined if posthog not initialized)
  if (consentStatus !== 'pending' && consentStatus !== undefined) {
    return null
  }

  // Don't show banner if PostHog is not configured
  if (!posthog) {
    return null
  }

  return (
    <div className="sticky bottom-0 px-4 sm:px-6 py-6 bg-body text-text border-t border-foreground/20 z-50">
      <div className="max-w-screen-lg mx-auto flex flex-col sm:flex-row items-center sm:items-center justify-between gap-4">
        <p className="text-sm text-center sm:text-left">
          {translations.message}{' '}
          <a
            href={translations.privacyHref}
            className="underline text-secondary hover:text-secondary/80"
          >
            {translations.privacyLink}
          </a>
        </p>
        <div className="flex gap-3 shrink-0">
          <button
            onClick={handleDecline}
            className="px-4 py-2 text-sm border border-foreground rounded hover:bg-foreground hover:text-body transition-colors"
          >
            {translations.decline}
          </button>
          <button
            onClick={handleAccept}
            className="px-4 py-2 text-sm bg-secondary text-secondary-foreground rounded hover:opacity-90 transition-opacity"
          >
            {translations.accept}
          </button>
        </div>
      </div>
    </div>
  )
}
